import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { auth } from '../lib/supabase';

export default function Login() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const { error: err } = await auth.signIn(email, password);
    setBusy(false);
    if (err) setError(err.message);
    else navigate('/');
  };

  return (
    <div className="container section" style={{ maxWidth: 420 }}>
      <h1>{t('auth.login')}</h1>
      <form className="card" onSubmit={submit}>
        <label className="field"><span>{t('auth.email')}</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label className="field"><span>{t('auth.password')}</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {error && <div className="banner" style={{ background: 'var(--red-soft)', color: 'var(--red)' }}>{error}</div>}
        <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy}>{t('auth.login')}</button>
        <p className="muted" style={{ marginTop: 12, textAlign: 'center' }}>
          {t('auth.noAccount')} <Link to="/register">{t('auth.register')}</Link>
        </p>
      </form>
    </div>
  );
}
